import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '../components/dashboard/dashboard.vue';
import Compliance from '../components/compliance/compliance.vue';
import ComplianceDetail from '../components/compliance/complianceDetail.vue';
import ComplianceDetailLog from '../components/compliance/ComplianceDetailLog.vue';
import Audit from '../components/audit/audit.vue';
import Policy from '../components/policy/policy.vue';
import PolicyDetail from '../components/policy/policyDetail.vue';
import PolicyReplica from '../components/policy/policyReplica.vue';
import SettingsWhitelist from '../components/settings/settingsWhitelist.vue';
import SettingsWhitelistModify from '../components/settings/settingsWhitelistModify.vue';
import SettingsCategory from '../components/settings/settingsCategory.vue';
import SettingsRegion from '../components/settings/SettingsRegion.vue';
import SettingsAccount from '../components/settings/settingsAccount.vue';
import systemPolicy from "../components/bestpractice/systempolicy.vue";
import systemPolicyDetail from "../components/bestpractice/systempolicyDetail.vue";
import { requireAuth } from '../components/common/AuthGuard.js';

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
    });
};

export default new Router({
    mode: 'history',
    linkActiveClass: "selected",
    routes: [
        {
            path: '/',
            redirect: '/dashboard'
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            beforeEnter: requireAuth
        },
        {
            path: '/compliance',
            name: 'Compliance',
            component: Compliance,
            beforeEnter: requireAuth
        },
        {
            path: '/compliance/detail',
            name: 'ComplianceDetail',
            component: ComplianceDetail,
            beforeEnter: requireAuth
        },
        {
            path: '/compliance/log',
            name: 'ComplianceDetailLog',
            component: ComplianceDetailLog,
            beforeEnter: requireAuth
        },
        // {
        //     path: '/compliance/cmplId=:cmplId/rsltId=:rsltId',
        //     name: 'ComplianceDetailWithResultID',
        //     component: ComplianceDetail,
        //     beforeEnter: requireAuth
        // },
        {
            path: '/audit',
            name: 'Audit',
            component: Audit,
            beforeEnter: requireAuth
        },
        {
            path: '/audit/detail',
            name: 'AuditWithPlcyId',
            component: Audit,
            beforeEnter: requireAuth
        },
        {
            path: '/policy',
            name: 'Policy',
            component: Policy,
            beforeEnter: requireAuth
        },
        {
            path: '/policy/detail',
            name: 'PolicyDetail',
            component: PolicyDetail,
            beforeEnter: requireAuth
        },
        {
            path: '/policy/replica',
            name: 'PolicyReplica',
            component: PolicyReplica,
            beforeEnter: requireAuth
        },
        {
            path: '/settings',
            redirect: '/settings/whitelist',
            beforeEnter: requireAuth
        },
        {
            path: '/settings/whitelist',
            name: 'SettingsWhitelist',
            component: SettingsWhitelist,
            beforeEnter: requireAuth
        },
        {
            path: '/settings/whitelist/:wtlId',
            name: 'SettingsWhitelistModify',
            component: SettingsWhitelistModify,
            beforeEnter: requireAuth
        },
        {
            path: '/settings/category',
            name: 'SettingsCategory',
            component: SettingsCategory,
            beforeEnter: requireAuth
        },
        {
            path: '/settings/region',
            name: 'SettingsRegion',
            component: SettingsRegion,
            beforeEnter: requireAuth
        },
        {
            path: '/settings/account',
            name: 'SettingsAccount',
            component: SettingsAccount,
            beforeEnter: requireAuth
        },
        {
            path: '/policy/mng/system',
            name: 'systemPolicy',
            component: systemPolicy,
            beforeEnter: requireAuth
        },
        {
            path: '/policy/mng/system/detail',
            name: 'systemPolicyDetail',
            component: systemPolicyDetail,
            beforeEnter: requireAuth
        },
        {
            path: '*',
            redirect: '/dashboard'
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js